<template>
  <div class="bar bar-top">
    <div class="d-flex justify-content-center">
      <div>
        <div class="info">
          <span>
            <strong>Questão {{ questionIndex + 1 }}</strong> de {{ totalQuestions }}
          </span>
          <span v-if="isTest">
            <span class="text-muted mx-3">|</span>
            <i class="far fa-clock icon mr-1"></i>
            <strong>{{ timer }}</strong>
          </span>
        </div>
      </div>
    </div>
  </div>
</template>

<script>
import moment from 'moment'

export default {
  name: 'BarHeader',
  components: {
  },
  props: {
    questionIndex: {
      type: Number
    }
  },
  data () {
    return {
      intervalTimer: null,
      startTime: moment(),
      currentTime: moment()
    }
  },
  computed: {
    questionnaire () {
      return this.$store.getters.getQuestionnaire
    },
    totalQuestions () {
      return this.questionnaire.questions.length
    },
    isTest () {
      return this.questionnaire ? this.questionnaire.type === 'test' : null
    },
    lastSeconds () {
      const diff = this.startTime.diff(this.currentTime, 'seconds')
      return this.questionnaire.countdown_seconds + diff
    },
    timer () {
      return moment()
      .startOf('day')
      .add(this.lastSeconds, 'second')
      .format('HH:mm:ss')
    }
  },
  beforeDestroy () {
    clearInterval(this.intervalTimer)
  },
  created () {
    if (this.isTest) {
      this.startTimer()
    }
  },
  methods: {
    startTimer () {
      this.intervalTimer = setInterval(() => {
        this.currentTime = moment()

        if (this.lastSeconds <= 0) {
          clearInterval(this.intervalTimer)
          this.$emit('finish')
        }
      }, 1000)
    }
  }
}
</script>

<style scoped>
</style>
